var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMliFeed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3063 0.37207H1.7415C0.785016 0.37207 0.00244141 1.15465 0.00244141 2.11113V14.2845C0.00244141 15.241 0.785016 16.0236 1.7415 16.0236H13.9149C14.8714 16.0236 15.6539 15.241 15.6539 14.2845V4.71971L11.3063 0.37207ZM13.9149 14.2845H1.7415V2.11113H10.4368V5.58924H13.9149V14.2845ZM3.48055 12.5455H12.1758V10.8064H3.48055V12.5455ZM7.82819 3.85018H3.48055V5.58924H7.82819V3.85018ZM3.48055 9.06735H12.1758V7.32829H3.48055V9.06735Z",
    fill: "#C0C6D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMliFeed);
export default __webpack_public_path__ + "static/media/mli-feed.e2648931ff841c4e31918908164ef921.svg";
export { ForwardRef as ReactComponent };